module.exports = __webpack_public_path__ + "static/img/620.ac1143b.png";